module.exports = __webpack_public_path__ + "img/1_on_1_class.ad971867.png";